module.exports = __webpack_public_path__ + "img/instagramestory9.96b8f508.jpg";